import { ContactType } from 'src/enums/ContactType';

export const isCustomContactType = (type: ContactType | string): boolean => {
  return type === ContactType.custom;
};
